/**
 * Specifies the type of delivery schedule.
 * tag: 41038
 * @readonly
 * @enum {number} (int)
 */
export enum DeliveryScheduleType {
  /** Notional */
  Notional = 0,
  /** Delivery */
  Delivery = 1,
  /** Physical settlement period */
  PhysicalSettlPeriods = 2,
}
